// const BASE_URL = "http://localhost:4000"
const BASE_URL = "https://bikeserver.onrender.com";
export default BASE_URL;
